import { Component, Input, OnInit, ViewChild, ElementRef, AfterViewChecked } from '@angular/core';
import { DialogService } from './dialog.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-dialog',
  templateUrl: './dialog.component.html',
  styleUrls: ['./dialog.component.scss']
})
export class DialogComponent implements OnInit {
  @Input() id!: string;
  @ViewChild('fecharBtn') fecharBtn!: ElementRef<HTMLButtonElement>;

  public botaoFechar: string = 'Fechar';
  private jaFocou = false;

  constructor(
    private dialogService: DialogService,
    private translate: TranslateService
  ) {}
  
  ngOnInit(): void {
    this.botaoFechar = this.translate.instant('Fechar');
  }
  
  ngAfterViewChecked(): void {
    if (this.aberto && this.fecharBtn && !this.jaFocou) {
      this.fecharBtn.nativeElement.focus();
      this.jaFocou = true;
    } else if (!this.aberto) {
      this.jaFocou = false; // resetar para quando abrir de novo
    }
  }

  get titulo() {
    return this.dialogService.getDialog(this.id)?.titulo;
  }

  get mensagem() {
    return this.dialogService.getDialog(this.id)?.mensagem;
  }

  get aberto() {
    return this.dialogService.getDialog(this.id)?.aberto;
  }

  fechar() {
    this.dialogService.fecharDialog(this.id);
  }
}
